import { jsx as _jsx } from "react/jsx-runtime";
/** The node path of each node's visibility parent (`godot/scene/visibilityParent.ts`), down the tree. */
import { createContext, useContext } from 'react';
import { spaceFamilyOf } from '../../godot/scene/parentSpace';
import { visibilityParentOf } from '../../godot/scene/visibilityParent';
import { useUniqueNamePaths } from '../useUniqueNames';
const VisibilityParentContext = createContext(null);
VisibilityParentContext.displayName = 'VisibilityParentContext';
/** Gives `node`'s visibility parent to the node's own component and to its descendants. */
export function VisibilityParentScope({ node, path, children }) {
    // Only a Node3D parent passes its visibility parent on (`node_3d.cpp:150`, `:1317`).
    if (spaceFamilyOf(node.type) !== 'Node3D') {
        return _jsx(VisibilityParentContext.Provider, { value: null, children: children });
    }
    const own = node.properties.visibility_parent;
    if (own === undefined)
        return children;
    return (_jsx(OwnVisibilityParent, { path: path, relative: own, children: children }));
}
function OwnVisibilityParent({ path, relative, children, }) {
    const visibilityParent = visibilityParentOf(path, relative, null, useUniqueNamePaths(path));
    return (_jsx(VisibilityParentContext.Provider, { value: visibilityParent, children: children }));
}
/** Gives `children` a visibility parent no enclosing node holds, as a node attached below an imported one has. */
export function VisibilityParentProvider({ value, children }) {
    return _jsx(VisibilityParentContext.Provider, { value: value, children: children });
}
/** The node path of the enclosing node's visibility parent, or null for none. */
export function useVisibilityParent() {
    return useContext(VisibilityParentContext);
}
//# sourceMappingURL=VisibilityParentContext.js.map